
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/store/notes/[slug]/[noteUID]",
      function () {
        return require("private-next-pages/store/notes/[slug]/[noteUID].jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/store/notes/[slug]/[noteUID]"])
      });
    }
  